import ServiceChannelsBody from './ServiceChannelsBody';

const View = (props) => <ServiceChannelsBody {...props} />;

export default View;
